export function cloneDeep(value) {
  if (typeof window.structuredClone === 'function') {
    return structuredClone(value);
  } else {
    return JSON.parse(JSON.stringify(value));
  }
}